<template>
    <div>
        <!-- getting data -->
        <template v-if="!this.gotData">
            <sau-loading>
                <template slot="message">Fetching Payment Details</template>
            </sau-loading>
        </template>
        <template v-else>
            <h3>Payment Details</h3>
            <div class="row">
                <div class="col">
                    <div class="sau-bx bx-pad">
                        <div class="row pb-6">
                            <div class="col-sm-12 col-md-6">
                                <ul class="sau-list-display">
                                    <li>
                                        <h5>Status</h5>
                                        <p>{{ service.status }}</p>
                                    </li>
                                    <li>
                                        <h5>Next Invoice Date</h5>
                                        <p v-if="service.next_invoice_date == '0000-00-00'">N/A</p>
                                        <p v-else>{{ service.next_invoice_date | moment('DD/MM/YYYY') }}</p>
                                    </li>
                                    <li>
                                        <h5>Billing Cycle</h5>
                                        <p>{{ service.billing_cycle }}</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <ul class="sau-list-display">
                                    <li>
                                        <h5>Recurring Amount</h5>
                                        <p v-if="parseFloat(service.amount) > 0">{{ service.amount | currency }} - {{ service.billing_cycle }}</p>
                                        <p v-else>Free Service</p>
                                    </li>
                                    <li>
                                        <h5>Next Due Date</h5>
                                        <p v-if="service.next_due_date == '0000-00-00'">N/A</p>
                                        <p v-else>{{ service.next_due_date | moment('DD/MM/YYYY') }}</p>
                                    </li>
                                    <li>
                                        <h5>Commencement Date</h5>
                                        <p>{{ service.reg_date | moment('DD/MM/YYYY') }}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- display invoice -->
            <div class="row mt-12" v-if="Object.keys(invoices).length > 0">
                <div class="col">
                    <h3>Invoices<span class="sau-help sm ml-2 align-middle" v-b-tooltip.hover title="This service appears as a line item on the following unpaid invoice(s)">?</span></h3>
                    <div class="sau-bx bx-pad">
                        <div class="row">
                            <div v-for="invoice in invoices" :key="invoice.id" class="col-lg-6 mb-6">
                                <div class="sau-bx bx-pad">
                                    <div class="d-flex justify-content-start pt-2">
                                        <div class="pr-4"><i class="fal fa-file-invoice fa-3x text-primary" aria-hidden="true"></i></div>
                                        <div class="pb-6">
                                            <p class="sau-para-m"><strong>Invoice Number:</strong> #{{ invoice.id }}</p>
                                            <p class="sau-para-m"><strong>Total:</strong> {{ invoice.total | currency }}</p>
                                            <p class="sau-para-m"><strong>Due Date:</strong> {{ invoice.duedate | moment('DD/MM/YYYY') }}</p>

                                            <a :href="downloadInvoiceLink(invoice.id)" target="_blank" class="sau-linx green sau-font sm">Download</a>
                                        </div>
                                    </div>
                                    <a :href="`/billing/invoices/${invoice.id}`" class="btn btn-primary px-6">View Invoice</a>
                                    <!-- <a href="#" class="sau-font sm" @click.prevent="selectedInvoice = invoice" v-b-modal.extension-request>Request Extension</a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Request Extension Form -->
            <sau-request-extension :invoice="selectedInvoice"></sau-request-extension>

        </template>

        <div class="row pt-6">
            <div class="col">
                <sau-spinner class="w-100" v-if="checkingCancellationStatus" />
                <template v-else>
                    <p v-if="pendingCancellation" class="sau-font sm">A cancellation request is currently pending for this service</p>
                    <p v-else>
                        <a :href="cancelUrl" title="Cancel this service" target="_blank">Cancel this service</a>
                    </p>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import SauSpinner from '@v1/utilities/SauSpinner';

export default {

    props: ['service'],

    components: { SauSpinner },

    data() {
        return {
            invoices: [],
            selectedInvoice: {},
            pendingCancellation: false,
            overdue: [],
            checkingCancellationStatus: false,
        }
    },
    created() {
        this.startApp();
    },
    methods: {
        startApp() {
            // Get invoices
            this.getServiceInvoices().then(response => {
                this.invoices = response.data;
            }).catch(error => {});
            // Check cancellation requests
            if(this.service.status.toLowerCase() == 'suspended') {
                this.disableLinks();
            }

            this.checkingCancellationStatus = true;
            this.getRequest(`/api/v2/services/${this.service.id}/cancel`)
                .then(({ data }) => {
                    this.pendingCancellation = data.pendingCancellation;
                })
                .finally(() => {
                    this.checkingCancellationStatus = false;
                });
        },
        clearDetails() {
            this.reasonSelected = [];
        },
        formatOverdueInvoices() {
            let response = this.overdue.length > 1 ? 'Invoices ' : 'Invoice ';
            this.overdue.forEach(function(invoice) {
                response += '#' + invoice + ', ';
            });
            // Trim the last gap and comma
            return response.substring(0, response.length - 2);
        },
        formatDueDate(invoice) {
            // Check if it is overdue or coming up
            let diff = moment().diff(moment(invoice.duedate), 'days');
            if(diff > 0) {
                // Overdue invoice - capture so it can be displayed if they try to cancel the service
                if(!this.overdue.includes(invoice.id)) {
                    this.overdue.push(invoice.id);
                }
                return Math.abs(diff) + ' days ago';
            } else {
                return 'In ' + Math.abs(diff) + ' days';
            }
        },
        disableLinks() {
            // set active class on all links where the href matches the current url
            let links = Array.from(document.querySelectorAll(`.sau-menu-aside ul li a`));
            links.forEach(function(link) {
                // Disable link - filter out summary and billing pages
                if(link.innerHTML != 'Summary' && link.innerHTML != 'Billing') {
                    link.classList.add('disable-link');
                    link.href = '#';
                }
             });
        }
    },
    computed:{
        cancelUrl() {
            return `/service/${this.service.type}/${this.service.id}/cancel`;
        }
    },
}
</script>
<style>
.disable-link {
    color: currentColor;
    cursor: not-allowed;
    opacity: 0.5;
    text-decoration: none;
}
</style>
